import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { TextArea } from '../../../components/common/Form';
import ImageUploader from '../../../components/common/Form/ImageUploader';
import ProfileSectionPage from '../../../components/ProfileSectionPage/ProfileSectionPage';
import { useBrandContext } from '../../../contexts/BrandContext';
import { updateBrand } from '../../../api/brand';
import { getBrandMedia, saveBrandMedia } from '../../../api/brandMedia';
import { BrandMediaItem } from '../../../types/BrandMediaInterface';
import { singleChange } from '../../../utils/brandMedia';
import BrandProfileActions from './BrandProfileActions';
import './styles/_brand-profile-about.scss';

const BrandAboutPage = () => {
  const { currentBrand, refreshCurrentBrand } = useBrandContext();

  const [description, setDescription] = useState('');
  const [savedCover, setSavedCover] = useState<BrandMediaItem | null | undefined>(undefined);
  const [coverImage, setCoverImage] = useState<Blob | string | null>(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setDescription(currentBrand?.description || '');
  }, [currentBrand]);

  useEffect(() => {
    if (!currentBrand) return;
    getBrandMedia(currentBrand.id)
      .then((media) => {
        setSavedCover(media.aboutCover);
        setCoverImage(media.aboutCover?.url ?? null);
      })
      .catch((error) => {
        console.error('Failed to load brand cover media:', error);
        toast.error('Failed to load cover page media.');
      });
  }, [currentBrand]);

  const handleSave = async () => {
    if (!currentBrand || isSaving) return;

    setIsSaving(true);

    try {
      await updateBrand(currentBrand.id, { description: description.trim() || null });

      if (savedCover !== undefined) {
        const cover = singleChange(savedCover, coverImage);
        if (cover.upload || cover.deleteID) {
          const media = await saveBrandMedia(currentBrand.id, {
            aboutCover: cover.upload,
            mediaToDelete: cover.deleteID ? [cover.deleteID] : []
          });
          setSavedCover(media.aboutCover);
          setCoverImage(media.aboutCover?.url ?? null);
        }
      }

      await refreshCurrentBrand();
      toast.success('About saved successfully.');
    } catch (error) {
      console.error('Failed to save brand description:', error);
      toast.error('Failed to save about.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <ProfileSectionPage title="ABOUT">
      <form className="location-profile-content" onSubmit={(e) => e.preventDefault()}>
        <div className="brand-about-page">
          <div className="brand-about-cover">
            <h2 className="brand-about-cover-heading">ABOUT SECTION MEDIA</h2>
            <p className="brand-about-cover-description">
              Choose a restaurant photo for the about section on your homepage.
            </p>
            <div className="brand-about-cover-media">
              <ImageUploader id="brand-about-cover" image={null} onUpdate={setCoverImage} />
              {coverImage && (
                <ImageUploader id="brand-about-cover-preview" image={coverImage} onUpdate={setCoverImage} />
              )}
            </div>
          </div>

          <TextArea
            name="description"
            label="TEXT"
            className="brand-about-description-input"
            value={description}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setDescription(e.target.value)}
            onBlur={() => {}}
            touched={false}
            error=""
          />

          <BrandProfileActions onSave={handleSave} isSaving={isSaving} />
        </div>
      </form>
    </ProfileSectionPage>
  );
};

export default BrandAboutPage;
